import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";
import { type ProgramEngine } from "../../../zodios/apiDefinitions/api/programs";
import { useModuleEnabled } from "../../../redux/selectors/modules";

type ProgramsFilter = { engine: ProgramEngine } | { pricing_plan: number };

/** The org's programs, plus its sibling orgs' with the MULTI_ORG_RULES module. */
export const usePrograms = (filter: ProgramsFilter, options?: { refetchOnMount?: "always" }) => {
  const all_user_orgs = useModuleEnabled("MULTI_ORG_RULES");
  const queries = { ...filter, all_user_orgs };

  return useQuery({
    // The "programs" prefix is what program create/edit/delete invalidate.
    queryKey: ["programs", queries],
    queryFn: async () => await apiClient.getPrograms({ queries }),
    select: (data) => data.results,
    ...options,
  });
};
